import { jsx as o } from "react/jsx-runtime";
const n = ({ size: C = 34, color: t = "currentColor", ...r }) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: C,
    height: C,
    viewBox: "0 0 32 22",
    fill: "none",
    ...r,
    children: /* @__PURE__ */ o(
      "path",
      {
        d: "M12.857 15.7142V6.28566L21.022 11L12.857 15.7142ZM31.0572 3.43531C30.6958 2.08317 29.631 1.01815 28.2788 0.656767C25.8277 0 15.9998 0 15.9998 0C15.9998 0 6.17192 0 3.72092 0.656767C2.3688 1.01815 1.30378 2.08317 0.942404 3.43531C0.285645 5.8863 0.285645 10.9999 0.285645 10.9999C0.285645 10.9999 0.285645 16.1137 0.942404 18.5646C1.30378 19.9166 2.3688 20.9818 3.72092 21.343C6.17192 22 15.9998 22 15.9998 22C15.9998 22 25.8277 22 28.2788 21.343C29.631 20.9818 30.6958 19.9166 31.0572 18.5646C31.7141 16.1137 31.7141 10.9999 31.7141 10.9999C31.7141 10.9999 31.7141 5.8863 31.0572 3.43531Z",
        fill: t
      }
    )
  }
);
export {
  n as YouTubeIcon
};
